// Central place to edit brand + business contact details.
// Update these values, and every legal/policy/contact page picks them up.
export const business = {
  name: "NovalynxTech",
  legalName: "NovalynxTech",           // used everywhere in body copy
  soleProprietor: "Ridtche Augustin",  // shown ONLY in small legal-entity footnote (required by law)
  website: "https://www.novalynxtech.com",
  supportEmail: "support@novalynxtech.com",
  contactEmail: "support@novalynxtech.com",
  address: {
    line1: "3650 Tates Creek Road",
    city: "Lexington",
    state: "KY",
    zip: "40517",
    country: "United States",
  },
  // Windows in calendar days
  returnWindowDays: 30,
  warrantyMonths: 12,
  freeShippingThreshold: 50,
  processingBusinessDays: "1-2",
  domesticShippingBusinessDays: "3-7",
  internationalShippingBusinessDays: "7-21",
  lastUpdated: "February 16, 2026",
};

export const fullAddress = () => {
  const a = business.address;
  return `${a.line1}, ${a.city}, ${a.state} ${a.zip}, ${a.country}`;
};
